import React, { FunctionComponent } from 'react';
import { Column } from '@iag-packages/chroma-react/lib/layouts';
import {
  FullPageContainer,
  FullPageRoot,
  FullPageRow,
  MobilePaddingContainer,
  StyledContainer,
  UpperContainer,
} from 'scenes/common/components/FullPageWrapper';
import Header from 'scenes/payments/components/Header';
import Footer from 'scenes/payments/components/Footer';

const PageWrapper: FunctionComponent = ({ children }) => (
  <FullPageRoot>
    <FullPageContainer>
      <FullPageRow displaySidebar={false}>
        <Column xs={12}>
          <UpperContainer>
            <div>
              <Header />
              <MobilePaddingContainer role="main">
                <StyledContainer>{children}</StyledContainer>
              </MobilePaddingContainer>
            </div>
            <Footer />
          </UpperContainer>
        </Column>
      </FullPageRow>
    </FullPageContainer>
  </FullPageRoot>
);

export default PageWrapper;
